export default function WebPage()
{
    return(
        <iframe src='https://sci.ind.in' style={{width:'100%',height:'600px',border:'none',margin:'0px'}} />        
    );
}